import React from 'react';
import moment from 'moment';
import SearchRideTitle from './components/SearchRideTitle';
import SearchRideTimes from './components/SearchRideTimes';
import './SearchRide.scss';
import SearchRideClass from './components/SearchRideClass';
import { ReactComponent as WheelChair } from '../../../../../../resources/images/svg/wheelchair.svg';
import { ReactComponent as Seat } from '../../../../../../resources/images/svg/seat.svg';

function SearchRide({
  ride,
  chosenRide,
  setChosenRide,
  seatFormation,
}) {
  const rideDetails = {
    rideNumber: ride.rideNumber,
    actualStartStationCode: ride.rideStartStation.station.code,
    actualEndStationCode: ride.rideEndStation.station.code,
    departure: {
      date: moment(ride.startStation.departureDateTime),
      stationCode: ride.startStation.station.code,
    },
    arrival: {
      date: moment(ride.endStation.arrivalDateTime),
      stationCode: ride.endStation.station.code,
    },
  };

  const classes = ride.availableSeatsClasses.filter((rideClass) => rideClass.seatClass.name !== 'პლაცკარტი').map((rideClass) => ({
    class: rideClass.seatClass.name,
    price: rideClass.priceOfSeats.amount,
    key: rideClass.seatClass.id,
    seats: rideClass.availableNumberOfSeats,
    ride: ride.id,
  })).sort((a, b) => a.price - b.price);

  const groupClasses = ride?.availableSeatsGroups?.filter((rideClass) => rideClass.seatClass.name !== 'პლაცკარტი').map((rideClass) => ({
    class: rideClass.seatClass.name,
    price: rideClass.priceOfSeats.amount,
    key: `group-${rideClass.seatClass.id}`,
    seats: rideClass.availableNumberOfSeats,
    ride: ride.id,
  }));

  return (
    <div className="bg-white rounded-2xl w-full flex flex-col gap-6 p-9">
      <SearchRideTitle ride={rideDetails} />
      <SearchRideTimes ride={rideDetails} />
      <div className="flex gap-4 flex-wrap flex-col lg:flex-row">
        {classes.map((rideClass) => (
          <SearchRideClass
            key={rideClass.key}
            data={rideClass}
            setChosenRide={setChosenRide}
            ride={ride}
            active={
            rideClass.ride === chosenRide?.id
                && chosenRide?.chosenClasses.find((key) => key === rideClass.key)
          }
            classIcon={<Seat />}
            chosenRide={chosenRide}
            seatFormation={seatFormation}
          />
        ))}
        {groupClasses.map((rideClass) => (
          <SearchRideClass
            key={rideClass.key}
            data={rideClass}
            setChosenRide={setChosenRide}
            ride={ride}
            active={
                rideClass.ride === chosenRide?.id
                && chosenRide?.chosenClasses.find((key) => key === rideClass.key)
            }
            classIcon={<div className="flex justify-center items-center w-5 h-5"><WheelChair /></div>}
            chosenRide={chosenRide}
            seatFormation={seatFormation}
          />
        ))}
      </div>
    </div>
  );
}

export default SearchRide;
